export const onLoadEvents = {
  MOBILE_NUMBER_EMAIL: "Landed_on_Mobile_&_Email",
  MOBILE_OTP: "Landed_on_Mobile_OTP",
  EMAIL_OTP: "Landed_on_Email_OTP",
  RESUME: "Landed_on_Resume",
  LINKEDIN: "Landed_on_LinkedIn",
  FULL_NAME: "Landed_on_Full_Name",
  TOTAL_EXPERIENCE: "Landed_on_Total_Exp",
  CURRENT_LOCATION: "Landed_on_Current_Location",
  NATIONALITY: "Landed_on_Nationality",
  WORK_AUTH: "Landed_on_Work_Auth",
  CURRENT_DESIGNATION_CURRENT_COMPANY: "Landed_on_Latest_Employment",
  SHOW_JR: "Landed_on_JR",
  START_DATE_CURRENTLY_WORKING_HERE_CHECKBOX: "Landed_on_Start_Date",
  END_DATE: "Landed_on_End_Date",
  SKILLS: "Landed_on_Skills",
  CURRENT_SALARY_HIDE_SALARY_CHECKBOX: "Landed_on_Salary_",
  NOTICE_PERIOD: "Landed_on_Notice_Period",
  LAST_WORKING_DAY: "Landed_on_Last_Working_Day",
  GENDER: "Landed_on_Gender",
  TRIUMPH_FIELDS: "Landed_on_Triumph_Page",
  HIGHEST_QUALIFICATION: "Landed_on_Highest_Qualification",
  QUALIFICATION_MEDIUM: "Landed_on_Medium",
  QUALIFICATION_BOARD: "Landed_on_Board",
  SPECIALISATION: "Landed_on_Specialisation",
  UNIVERSITY: "Landed_on_University",
  YEAR_OF_GRADUATION: "Landed_on_Graduation_Year",
  EDUCATION_TYPE: "Landed_on_Education_Type",
  PREFERRED_JOB_TITLE: "Landed_on_Preferred_JT",
  PREFERRED_LOCATION: "Landed_on_Preferred_Location",
  WHAT_ARE_YOU_LOOKING_FOR_CHECKBOX: "Landed_on_What_Are_You_Looking_For",
  SHOW_JR_TWICE: "Landed_on_JR_Twice",
  INDUSTRY: "Landed_on_Industry",
};
